import { EVENT_TYPES } from './constants';
import { reportFunc } from './utils';
import {
    enrichPageView,
    enrichRedirectButtonClicked,
    enrichSellerOverviewHovered,
    enrichAssetClicked,
    enrichAssetShown,
    enrichFooterShown,
    enrichFooterPlayed,
    enrichSellerClicked,
} from './enrichments';

export const reportPageView = reportFunc(EVENT_TYPES.PAGE_VIEW, enrichPageView);

export const reportRedirectButtonClicked = reportFunc(EVENT_TYPES.CLICKED_ON_CTA_BUTTON, enrichRedirectButtonClicked);

export const reportSellerOverviewHovered = reportFunc(
    EVENT_TYPES.HOVERED_ON_SELLER_DETAILS,
    enrichSellerOverviewHovered
);

export const reportAssetClicked = reportFunc(EVENT_TYPES.CLICKED_ON_ASSET, enrichAssetClicked);

export const reportAssetShown = reportFunc(EVENT_TYPES.ASSET_IS_SHOWN, enrichAssetShown);

export const reportFooterShown = reportFunc(EVENT_TYPES.FOOTER_IS_SHOWN, enrichFooterShown);

export const reportFooterPlayed = reportFunc(EVENT_TYPES.FOOTER_IS_PLAYED, enrichFooterPlayed);

export const reportSellerClicked = reportFunc(EVENT_TYPES.SELLER_IS_CLICKED, enrichSellerClicked);
